import classnames from 'classnames/bind'
import React, { forwardRef, useState } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'

import { Link, LinkProps } from '@unlikelystudio/react-abstract-components'

import { ImageProps } from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type IndexListItemProps = {
  className?: string
  isActive?: boolean
  forwardRef?: any
  index?: number
  title?: string
  link?: LinkProps
  firstLetter?: string
  cardImage?: ImageProps
  cardSecondImage?: ImageProps
  onMouseEnter?: (index) => void
  onMouseOut?: () => void
}

function IndexListItem({
  className,
  forwardRef,
  index,
  title,
  link,
  isActive,
  onMouseEnter,
  onMouseOut,
}: IndexListItemProps) {
  const linkStyle = useStyle({
    textPreset: GlobalTextPreset.Title20SangBleuLight,
  })

  return (
    <Link
      ref={forwardRef}
      className={cx(css.IndexListItem, linkStyle, className, { isActive })}
      onMouseEnter={(e) => {
        onMouseEnter && onMouseEnter(index)
      }}
      onMouseLeave={(e) => {
        onMouseOut && onMouseOut()
      }}
      {...link}>
      {title}
    </Link>
  )
}

IndexListItem.defaultProps = {}

export default IndexListItem
